import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'dmmp-basic-view',
  templateUrl: './basic-view.component.html'
})
export class BasicViewComponent{

  @Input() basicInfo
  @Input() module

  constructor() { }
}
